import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Modal from "../../../../../components/modal/modal.component";
import {Notification} from "@models/notification";
import {StyledButton} from "@components/button/button.style";
import {StyledFooter} from "@components/pane/pane.style";
import {StyledModalContent} from "@components/modal/modal.style";
import {disableSwipeToClose} from "@utils/tools/modals";
import {stripHtmlTags} from "@utils/tools/string";
import {IonLoading} from "@ionic/react";
import {acceptObligatoryNotification} from "@services/push.service";

type PreviewModalProps = {
    isOpen: boolean;
    notification?: Notification | null;
    onClose: () => void;
    onAction: () => void;
    onObligatoryAccept: () => void;
    buttonText?: string
};

const PreviewModal: React.FC<PreviewModalProps> = (props: PreviewModalProps) => {
    const {t} = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showPreviewModal, setShowPreviewModal] = useState<boolean>(false);

    useEffect(() => {
        handleOpen();
    });

    const handleClose = () => {
        props.onClose();
    };

    const handleOpen = () => {
        setShowPreviewModal(props.isOpen);
    };

    const handleAcceptObligatory = async () => {
        if (!props.notification) {
            return;
        }

        setIsLoading(true);

        try {
            await acceptObligatoryNotification(props.notification.notification.id);
        } catch (error) {
            console.error(error);
        } finally {
            props.onObligatoryAccept();
        }

        setIsLoading(false);
    }

    return (
        <>
            <Modal
                isOpen={showPreviewModal}
                canDismiss={disableSwipeToClose}
                maxHeight={'75%'}
                onDidDismiss={() => handleClose()}
            >
                <StyledModalContent className="notification">
                    <h1 className="title">{stripHtmlTags(props.notification?.notification.subject || '')}</h1>
                    <div className="date">{props.notification?.notification.sent_date}</div>
                    <div className={props.notification?.notification.redirect_to && props.buttonText ? "content" : "content full-height"}>
                        <div dangerouslySetInnerHTML={{__html: props.notification?.notification.body || ''}}/>
                    </div>
                    {
                        ((props.notification?.notification.redirect_to && props.buttonText) || props.notification?.notification.is_obligatory) &&
                        <StyledFooter className="modal footer no-shadow">
                            {
                                props.notification?.notification.redirect_to && props.buttonText &&
                                <StyledButton onClick={event => props.onAction()}>{props.buttonText}</StyledButton>
                            }
                            {
                                props.notification?.notification.is_obligatory && !props.notification.obligatory_accepted_at &&
                                <StyledButton onClick={handleAcceptObligatory}>{t("notificationPreview.acceptObligatory")}</StyledButton>
                            }
                        </StyledFooter>
                    }
                </StyledModalContent>
            </Modal>
            <IonLoading isOpen={isLoading}/>
        </>
    );
};

export default PreviewModal;
